<template>
  <div
    ref="editor"
    class="monaco-editor"
  />
</template>

<script>
import * as monaco from 'monaco-editor'

/**
 * Monaco Editor Component
 * javascript editor component
 */
export default {
  name: 'MonacoEditor',
  props: {
    /**
     * editor value set
     * @param {String} code
     */
    code: {
      type: String,
      default: ''
    },
    /**
     * editor language set
     * @param {String} language
     * ex) javascript, typescript ...
     */
    language: {
      type: String,
      default: 'javascript'
    },
    /**
     * editor theme set
     * @param {String} theme
     * ex) vs, vs-dark ...
     */
    theme: {
      type: String,
      default: 'vs'
    },
    /**
     * editor automatic layout set
     * @param {String} automaticLayout
     */
    automaticLayout: {
      type: Boolean,
      default: false
    },
    /**
     * Usable ParameterList
     * @param {Array} parameterList
     */
    parameterList: {
      type: Array,
      default () {
        return []
      }
    },
    /**
     * editor component 사용하는 page 명
     * @param {String} parentPage
     */
    parentPage: {
      type: String,
      default: null
    },
    /**
     * Usable ContextNameList
     * @param {Array} contextNameList
     */
    contextNameList: {
      type: Array,
      default () {
        return []
      }
    },
    /**
     * Usable StepList
     * @param {Array} stepList
     */
    stepList: {
      type: Array,
      default () {
        return []
      }
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    code: function (newVal) {
      if (this.codeValue !== newVal) {
        this.editor.setValue(newVal)
        this.codeValue = newVal
      }
    },
    parameterList: function (value) {
      // var index = 0
      // monaco.languages.registerCompletionItemProvider('javascript', {
      //   provideCompletionItems: function(model, position) {

      //     console.log('provideCompletionItems')
      //     var textUntilPosition = model.getValueInRange({
      //       startLineNumber: position.lineNumber,
      //       startColumn: 1,
      //       endLineNumber: position.lineNumber,
      //       endColumn: position.column
      //     })
      //     console.log('textUntilPosition', textUntilPosition)

      //     var word = model.getWordUntilPosition(position)
      //     console.log('word', word)
      //     var range = {
      //       startLineNumber: position.lineNumber,
      //       endLineNumber: position.lineNumber,
      //       startColumn: word.startColumn,
      //       endColumn: word.endColumn
      //     }
      //     console.log('range', range)

      //     let suggestions = textUntilPosition.trim().match(/Brique.getParameterValue/g) ? createDependencyProposals(range, value) : []
      //     console.log('suggestions', suggestions)
      //     console.log('index', index)
      //     if(index === 0) {
      //       index += 1
      //       return {
      //           suggestions: suggestions
      //       }
      //     }
      //   }
      // });
      // function createDependencyProposals(range, list) {
      //   console.log('createDependencyProposals', list)
      //   let suggestions = []
      //   for (var i = 0; i < list.length; i++) {
      //     let obj = {
      //       label: 'ParamName.'+list[i].paramName,
      //       kind: monaco.languages.CompletionItemKind.Text,
      //       insertText: '"'+list[i].paramName+'"',
      //       range: range,
      //       sortText: '0'
      //     }
      //     suggestions.push(obj)
      //   }
      //   return suggestions
      // }
    }
  },
  mounted () {
    const el = this.$refs.editor
    this.editor = monaco.editor.create(el, {
      value: this.code,
      language: this.language,
      theme: this.theme,
      automaticLayout: this.automaticLayout,
      readOnly: this.readOnly
    })

    this.codeValue = this.code

    this.editor.onDidChangeModelContent(() => {
      this.codeValue = this.editor.getValue()
      // editor value를 부모 요소에 setting
      this.$emit('set-code-value', this.codeValue)

      if (this.parentPage === 'VirtualParameter') {
        this.editor.focus()

        // get cursor position (linenumber, column 위치를 한단계씩 이전 단계를 가져오는 증상으로 timeout 적용)
        setTimeout(() => {
          this.$emit('get-cursor-position', this.editor.getPosition())
        }, 10)
      }
    })

    if (this.parentPage === 'VirtualParameter') {
      // mouse leave 시 cursor position 전달 (필요시에 넣을 것)
      // this.editor.onMouseLeave(() => {
      //   this.$emit('get-cursor-position', this.editor.getPosition())
      // })
      this.editor.onMouseUp(() => {
        this.$emit('get-cursor-position', this.editor.getPosition())
      })

      // Brique class 설정 (Brique.getParameterValue, Brique.getContextValue)
      monaco.languages.typescript.typescriptDefaults.setCompilerOptions({
        allowNonTsExtensions: true,
        noLib: true
      })

      monaco.languages.typescript.javascriptDefaults.addExtraLib([
        'declare class Brique {',
        '     static getParameterValue(paramName: string);',
        '     static getParameterValues(paramName: string, stepId: string);',
        '     static getContextValue(contextName: string);',
        '     static getRunTime(stepId: string);',
        '     static getLotTimeout();',
        '     static getSubstTimeout();',
        '     static getTraceTimeout();',
        '     static getPrevParameterValue(paramName: string, prevSeq: number);',
        '}'
      ].join('\n'))

      // getParameterValue function 내부에서 parameter list 추천 설정
      monaco.languages.registerCompletionItemProvider('javascript', {
        provideCompletionItems: function (model, position) {
          var textUntilPosition = model.getValueInRange({
            startLineNumber: position.lineNumber,
            startColumn: 1,
            endLineNumber: position.lineNumber,
            endColumn: position.column
          })

          var word = model.getWordUntilPosition(position)
          var range = {
            startLineNumber: position.lineNumber,
            endLineNumber: position.lineNumber,
            startColumn: word.startColumn,
            endColumn: word.endColumn
          }

          let suggestions = []

          if (textUntilPosition.trim().match(/Brique.getParameterValue/g)) {
            suggestions = createDependencyProposals('paramName', range)
          } else if (textUntilPosition.trim().match(/Brique.getParameterValues/g)) {
            suggestions = createDependencyProposals('paramName', range)
          } else if (textUntilPosition.trim().match(/Brique.getPrevParameterValue/g)) {
            suggestions = createDependencyProposals('paramName', range)
          } else if (textUntilPosition.trim().match(/Brique.getContextValue/g)) {
            suggestions = createDependencyProposals('contextName', range)
          } else if (textUntilPosition.trim().match(/Brique.getRunTime/g)) {
            suggestions = createDependencyProposals('stepId', range)
          } else {
            suggestions = []
          }

          return {
            suggestions: suggestions
          }
        }
      })
    }
    var self = this
    function createDependencyProposals (argName, range) {
      let suggestions = []
      if (argName === 'paramName') {
        let list = self.parameterList
        for (var i = 0; i < list.length; i++) {
          let obj = {
            label: 'paramName.' + list[i].paramName,
            kind: monaco.languages.CompletionItemKind.Text,
            insertText: '"' + list[i].paramName + '"',
            range: range,
            sortText: '0'
          }
          suggestions.push(obj)
        }

        let stepList = self.stepList
        for (var k = 0; k < stepList.length; k++) {
          let obj = {
            label: 'stepId.' + stepList[k],
            kind: monaco.languages.CompletionItemKind.Text,
            insertText: '"' + stepList[k] + '"',
            range: range,
            sortText: '0'
          }
          suggestions.push(obj)
        }
      } else if (argName === 'contextName') {
        let list = self.contextNameList
        for (var j = 0; j < list.length; j++) {
          let obj = {
            label: 'contextName.' + list[j],
            kind: monaco.languages.CompletionItemKind.Text,
            insertText: '"' + list[j] + '"',
            range: range,
            sortText: '0'
          }
          suggestions.push(obj)
        }
      } else if (argName === 'stepId') {
        let stepList = self.stepList
        for (var l = 0; l < stepList.length; l++) {
          let obj = {
            label: 'stepId.' + stepList[l],
            kind: monaco.languages.CompletionItemKind.Text,
            insertText: '"' + stepList[l] + '"',
            range: range,
            sortText: '0'
          }
          suggestions.push(obj)
        }
      }
      return suggestions
    }
  },
  data: function () {
    return {
      codeValue: null
    }
  }
}
</script>

<style>
  .monaco-editor {
    width: 100%;
    height: 100%;
  }
</style>
